// client/src/components/messages/PresenceIndicator.js
import React from 'react';
import { Box, Tooltip } from '@mui/material';

const PresenceIndicator = ({ lastSeen, isOnline = false }) => {
  const getStatus = () => {
    if (isOnline) return 'online';
    
    if (!lastSeen) return 'offline';
    
    const now = new Date();
    const lastSeenDate = new Date(lastSeen);
    const diffMinutes = Math.floor((now - lastSeenDate) / (1000 * 60));
    
    if (diffMinutes < 5) return 'online';
    if (diffMinutes < 30) return 'away';
    return 'offline';
  };

  const getColor = (status) => {
    switch (status) {
      case 'online': return '#44b700';
      case 'away': return '#ffa726';
      case 'offline': return '#757575';
      default: return '#757575';
    }
  };

  const getLabel = (status) => {
    switch (status) {
      case 'online': return 'Online';
      case 'away': return 'Away';
      case 'offline': return 'Offline';
      default: return 'Unknown';
    }
  };

  const status = getStatus();
  const color = getColor(status);
  const label = getLabel(status);

  return (
    <Tooltip title={label}>
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: color,
          border: '2px solid white',
          position: 'absolute',
          top: 0,
          left: 0,
          boxShadow: '0 0 0 2px rgba(0,0,0,0.1)'
        }}
      />
    </Tooltip>
  );
};

export default PresenceIndicator;
